import styled from '@mui/system/styled';
import Stack from '@mui/material/Stack';

// This wrapper is here to sync the borders used to indicate the inputs state
// (default, hovered, focused). This way the image preview will look the same
// as the text input.
const BorderWrapper = styled(Stack)(({ theme }) => ({
  ':has(:is(input,  button):hover) :is( .placeholder)': {
    border: `1px solid ${theme.palette.text.primary}`,
  },
  ':has(:is(input):focus) :is(placeholder)': {
    border: `2px solid ${theme.palette.primary.main}`,
  },
}));

export default BorderWrapper;
